import type { ThemeOptions } from '@mui/material/styles';

import { MuiButtonBase } from 'theme/components/button-base';
import { MuiCheckbox } from 'theme/components/checkbox';
import { MuiCircularProgress } from 'theme/components/circular-progress';
import { MuiFormControlLabel } from 'theme/components/form-control-label';
import { MuiLinearProgress } from 'theme/components/linear-progress';
import { MuiOutlinedInput } from 'theme/components/outlined-input';
import { MuiRadio } from 'theme/components/radio';
import { MuiStack } from 'theme/components/stack';
import { MuiSwitch } from 'theme/components/switch';
import { MuiTypography } from 'theme/components/typography';

export const components: ThemeOptions['components'] = {
  MuiButtonBase,
  MuiCheckbox,
  MuiCircularProgress,
  MuiFormControlLabel,
  MuiLinearProgress,
  MuiOutlinedInput,
  MuiRadio,
  MuiStack,
  MuiSwitch,
  MuiTypography,
};
